import { render } from "./SleepDebtNeedComboChart.vue?vue&type=template&id=3890cbb2&scoped=true"
import script from "./SleepDebtNeedComboChart.vue?vue&type=script&lang=js"
export * from "./SleepDebtNeedComboChart.vue?vue&type=script&lang=js"

import "./SleepDebtNeedComboChart.vue?vue&type=style&index=0&id=3890cbb2&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3890cbb2"]])

export default __exports__